import { fetchJson } from '@atlassian/jira-fetch/src/index.tsx';
import type { FetchInput } from '@atlassian/expansion-services/services';

export const jiraFetchJson = (input: FetchInput) => {
	const url = input.url;
	const options = input;
	return fetchJson(url, options);
};
